/** The toolbar and agent coverage inventory share these tool IDs. */
export const workspaceToolGroups = {
  Workspace: [
    "select",
    "sheet",
    "document",
    "import",
    "library",
    "table",
    "search",
    "move",
  ],
  Draw: [
    "line",
    "draw",
    "geo",
    "polyline",
    "polygon",
    "circle",
    "curve",
    "wall",
    "door",
    "window",
    "eraser",
  ],
  Annotate: [
    "text",
    "arrow",
    "pin",
    "leader",
    "highlight",
    "cloud",
    "note",
    "comment-area",
  ],
  Measure: ["dimension", "area", "trace", "angle"],
} as const;
export const workspaceAgentCoverage = {
  select: "read_canvas",
  search: "read_canvas",
  move: "move",
  sheet: "create_sheet",
  document: "add_document",
  import: "workspace_tool:import_file",
  library: "workspace_tool:library",
  table: "add_table",
  line: "add_line",
  draw: "add_stroke",
  geo: "add_geometry",
  polyline: "add_drafting",
  polygon: "add_mark",
  circle: "add_drafting",
  curve: "add_drafting",
  wall: "add_drafting",
  door: "add_drafting",
  window: "add_drafting",
  eraser: "delete_objects",
  text: "add_text",
  arrow: "add_arrow",
  pin: "add_comment",
  leader: "add_drafting",
  highlight: "add_stroke",
  cloud: "add_cloud",
  note: "add_note",
  "comment-area": "add_comment",
  dimension: "add_mark",
  area: "add_mark",
  trace: "add_trace",
  angle: "add_mark",
} as const;
